import { AfterViewChecked, Component, EventEmitter, Input, NgZone, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ConfirmationService, MessageService, Message } from 'primeng/api';
import { FAZILService, User, UserService } from 'src/app/core';
import { UIService } from 'src/app/core/services/ui.service';
import { environment } from 'src/environments/environment';
import { ServiciosService } from 'src/app/servicios/servicios.service';
import { Product } from 'src/app/modelo/Product';

import { AdministracionService } from 'src/app/administracion/administracion.service';
import { validateDni } from 'src/app/shared/helpers';
import { validateRUC } from 'src/app/shared/helpers';
import { validateEmail } from 'src/app/shared/helpers';

import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { FazilController } from '../core/fazil-controller-component';
import { FormBuilder } from '@angular/forms';
import { ProductoOutput } from 'src/app/core/models/producto.model';

import { Subscription } from 'rxjs';
import { Subject as SubjectRXJS } from 'rxjs';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';

@Component({
    selector: 'app-producto-buscador',
    templateUrl: './producto-buscador.component.html',
    styleUrls: ['./servicios.component.scss']
})
export class ProductoBuscadorComponent  extends FazilController  implements OnInit, AfterViewChecked, OnChanges {

    //Variables de configuración/mensajes
    appConfig = environment.settings;

    errors: Object = {};
    msgs: Message[] = [];

    _producto: Product = new Product();
    _productSelected: Product = new Product();
    
    //Variables auxiliares
    cargandoDataInit: boolean = false;
    procesando: boolean = false;

    _mostrarBuscador: boolean = false;
    
    _mostrarEditor: boolean = false;
    
    @Output() productoSeleccionado = new EventEmitter<ProductoOutput>();
    @Output() productoDeseleccionado = new EventEmitter<ProductoOutput>();
    
    @Input() estaCargandoDatos: boolean = false;
    
    @Input() cargarTodos = false;
    
    products: Product[] = [];
    productsFiltered: Product[] = [];
    processFilter:boolean = false;
    seRealizoBusquedaEspecifica:boolean = false;
    
    filterDebounceTime: number = 500;
    filterTextChanged: SubjectRXJS<any> = new SubjectRXJS<any>();
    
    visible:boolean = false;

    constructor(
        private zone: NgZone,
        private router: Router,
        private route: ActivatedRoute,
        private fazilService: FAZILService,
        private confirmationService: ConfirmationService,
        private serviciosService: ServiciosService,
        private sanitizer: DomSanitizer,
        public override uiService: UIService,
        public override messageService: MessageService,
        public override administracionService: AdministracionService,
        public override _formBuilder: FormBuilder
    ) {
        super(uiService, messageService, administracionService, _formBuilder);
    }
    
    ngOnChanges(changes: SimpleChanges): void {
        this.visible = this.mostrarBuscador;
    }
    
    ngOnInit(): void {
        this.initComponent();
    }
    
    ngAfterViewChecked(): void {
        //dummy
    }
    
    //Detecta los cambios desde fuera del componente
//    ngOnChanges(changes: SimpleChanges): void {
//        //TODO Entender para que es
//        //throw new Error('Method not implemented.');
//    }
//    
    async initComponent() {
        
        if (this.cargarTodos){
            this.processFilter = true;
            this.pageOptions = { page: 0, pageSize: 999, filter: '', orderBy: 'name', order:'ASC' };//Todos los productos
            const data = await this.serviciosService.getProductosPorOrganizacionDeUsuarioConectadoData(this.pageOptions);
            this.products = data['content'];
            this.productsFiltered = [...this.products]
            this.processFilter = false;
        }
                    
        this.estaCargandoDatos = false;
        this.resetVariablesProducts();
    }
    
    //Accesores
    @Input() 
    set mostrarBuscador(v){
        this._mostrarBuscador = v;
    }
    
    get mostrarBuscador(){
        return this._mostrarBuscador;
    }
    
    @Input() 
    set mostrarEditor(v){
        this._mostrarEditor = v;
    }
    
    get mostrarEditor(){
        return this._mostrarEditor;
    }
    
    async filteredProductByKeywordRemote($event) {
        if (this.filterTextChanged.observers.length === 0) {
            this.filterTextChanged.pipe(debounceTime(this.filterDebounceTime), distinctUntilChanged()).subscribe(async query => {
                if (query.$event.target.value.length > 2) {
                    this.processFilter = true;
                    const keyword = query.$event.target.value.toLocaleLowerCase();
                    this.pageOptions = { page: 0, pageSize: 999, filter: keyword, orderBy: 'name', order:'ASC' };
                    const data = await this.serviciosService.getProductosPorOrganizacionDeUsuarioConectadoData(this.pageOptions);
                    this.productsFiltered = data['content'];
                    this.processFilter = false;
                }
            });
        }
        this.filterTextChanged.next({ $event });
    }
    
    async filteredProductByKeywordLocal($event) {
        if (this.filterTextChanged.observers.length === 0) {
            this.filterTextChanged.pipe(debounceTime(this.filterDebounceTime), distinctUntilChanged()).subscribe(query => {
                if (query.$event.target.value.length > 2) {
                    this.processFilter = true;
                    const keyword = query.$event.target.value.toLocaleLowerCase();
                    this.productsFiltered = this.ui.filteredListByField(this.products, 'name', keyword);
                    this.processFilter = false;
                }
            });
        }
        this.filterTextChanged.next({ $event });
    }
    
    resetVariablesProducts(): void {
        this.ui.limpiarMessages();
        this.mostrarEditor = false;
        this._producto = new Product();
    }

    nuevoProducto() {
        this.resetVariablesProducts();
        this.mostrarEditor = true;
    }
    
    editarProducto(event, item: Product) {
        this._producto = item;
        this.mostrarEditor = true;
    }
    
    
    seleccionarProducto(event, item: Product){
        this.productoSeleccionado.emit({
            data: item,
            success: true,
            message: '¡Producto seleccionado!'
        });
        this.cerrarPopup(true);
    }
    
    deseleccionarProducto(event, item: Product){
        this.productoDeseleccionado.emit({
            data: item,
            success: true,
            message: '¡Producto deseleccionado!'
        });
        this.cerrarPopup(true);
    }
    
    cerrarPopup(seleccionado:boolean){
        this.visible = false;
        let mensaje = "Se cierra la venta de búsqueda.";
        if (!seleccionado){
            this.productoDeseleccionado.emit({
                  data: this._producto,
                  success: seleccionado,
                  message: mensaje,
                });
        }
    }
    
    handleProductoGuardado(productoOutput:ProductoOutput){
        
        if (productoOutput.success){
            this.seleccionarProducto( null, productoOutput.data );
        }   
    }
    
    @Input()
    set currentUser(currentUser: User) {
        this._currentUser = currentUser
    }

    get currentUser() { return this._currentUser; }
}
